import React, { memo, useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

import action from '@flux/action';
import { ExpandButton } from '@components';
import TabComp from './tabComp';
import SingleComp from './singleCompany';
import FullScreenComp from './fullScreenComp';
import { stockViarietyModel, stockTimeRangeBtns } from '@model';

// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
// import '@style/modules/analysis/expandButton.scss';
import '../../../../styles/modules/analysis/expandButton.scss';
import {
  getValueFromSearchParam,
  removeValueFromSearchParam,
  setURLSearchParam,
} from '@utils/history';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';

function TickerAndStock(props) {
  const { tab: defaultValue, expand: initialExpand = false } =
    getValueFromSearchParam(searchParamKeys.tab, searchParamKeys.expand);
  const [expand, setExpand] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRange, setRange] = useState(2);

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);

  const expandCharts = () => {
    setExpand(!expand);
    if (!expand) {
      setURLSearchParam(history, {
        [searchParamKeys.expand]: true,
      });
    } else {
      removeValueFromSearchParam(history, [searchParamKeys.expand]);
    }
  };

  const {
    chartData,
    data: { ah = [] } = {},
    currentId,
    isSingleCompany,
    fetchData,
  } = props;

  const [
    { companyName: buyerName = 'BUYER' },
    { companyName: targetName = 'TARGET' } = {},
  ] = ah;

  useEffect(() => {
    if (Object.keys(chartData).length && props.data && initialExpand) {
      setExpand(true);
    }
  }, [chartData, props.data]);

  useEffect(() => {
    if (isSingleCompany) {
      const { buyer = {} } = chartData;

      const hasBuyerData = Object.keys(buyer).length > 0;

      if (!hasBuyerData && !isLoading) {
        (async () => {
          setIsLoading(true);
          await fetchData(currentId);
          setIsLoading(false);
        })();
      }
    } else {
      const { buyer = {}, target = {} } = chartData;

      const hasBuyerData = Object.keys(buyer).length > 0;
      const hasTargetData = Object.keys(target).length > 0;

      if (!hasBuyerData && !hasTargetData && !isLoading) {
        (async () => {
          setIsLoading(true);
          await fetchData(currentId);
          setIsLoading(false);
        })();
      }
    }
  }, [currentId, fetchData, chartData, isLoading, isSingleCompany]);

  const childrenProps = {
    data: chartData,
    isLoading,
    buyerName,
    targetName,
    selectedRange,
    timeRangeBtns: stockTimeRangeBtns,
    changeRange: setRange,
    varietyModel: stockViarietyModel,
    isSingleCompany,
    defaultValue,
    onTabChange,
  };

  return (
    <div className={`analysis-right-wrapper ${expand && 'full-screen'}`}>
      <div
        className={`title expand-box ${
          expand ? 'full-screen-title' : 'title-no-bottom-border'
        }`}
      >
        <div>Ticker and Stock Exchange</div>
        {!isLoading && !isSingleCompany && (
          <ExpandButton
            onClick={expandCharts}
            scrollPageFooter
            initialExpand={initialExpand}
          />
        )}
      </div>

      {(() => {
        if (isSingleCompany) {
          return <SingleComp {...childrenProps} />;
        }

        if (!expand) {
          return <TabComp {...childrenProps} />;
        }
        return <FullScreenComp {...childrenProps} />;
      })()}
    </div>
  );
}

const mapStateToProps = ({ common, analysis }) => {
  const currentId = common.currentId;
  return {
    chartData: (analysis.stockData || {})[currentId] || {},
    currentId,
  };
};

const mapDispatchToData = (dispatch) => ({
  async fetchData(id) {
    await dispatch(action.fetchStockData(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToData,
)(memo(TickerAndStock));
